import { createSlice } from "@reduxjs/toolkit";

export interface RequirementItem {
  id: number;
  title: string;
  positions: number;
  skills: string[];
  priority: string;
  status: string;
  salary_min: number;
  salary_max: number;
  currency: string;
  description: string | null;
  location: string | null;
  created_at: string;
  updated_at: string;
  jobs_posted: number;
  jobs: unknown[];
}

export interface RecruiterStatsData {
  recruiter_id: string;
  recruiter_name: string;
  recruiter_email: string;
  total_requirements_assigned: number;
  total_jobs_posted: number;
  total_jobs_assigned: number;
  total_jobs_reassigned: number;
  total_jobs_transferred: number;
  total_open_positions: number;
  total_closed_positions: number;
  job_closure_rate: number;
  total_credits_allotted: number;
  reassigned_jobs: unknown[];
  transferred_jobs: unknown[];
  requirements: RequirementItem[];
}

export interface AdminStatsData {
  admin_id: string;
  admin_name: string;
  admin_email: string;
  total_requirements_raised: number;
  total_jobs_posted: number;
  total_jobs_assigned: number;
  total_open_positions: number;
  total_closed_positions: number;
  job_closure_rate: number;
  total_credits_balance: number;
  requirements: RequirementItem[];
}

export interface MemberStatsState {
  recruiterData: RecruiterStatsData | null;
  adminData: AdminStatsData | null;
  loading: boolean;
  error: string | null;
}

const initialState: MemberStatsState = {
  recruiterData: null,
  adminData: null,
  loading: false,
  error: null,
};

const memberStatsSlice = createSlice({
  name: "memberStats",
  initialState,
  reducers: {
    setMemberStatsLoading: (state, action) => {
      state.loading = action.payload;
    },
    setMemberStatsError: (state, action) => {
      state.error = action.payload;
    },
    setRecruiterStats: (state, action) => {
      state.recruiterData = action.payload;
    },
    setAdminStats: (state, action) => {
      state.adminData = action.payload;
    },
    clearMemberStats: (state) => {
      state.recruiterData = null;
      state.adminData = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setMemberStatsLoading,
  setMemberStatsError,
  setRecruiterStats,
  setAdminStats,
  clearMemberStats,
} = memberStatsSlice.actions;

export default memberStatsSlice.reducer;
